import React from 'react'

export const TabAttivitaSettings = (settingsProps) => {
  return (
    <div className="empty-message">
      <p>No options available</p>
    </div>
  )
}
